import { jsx as _jsx } from "react/jsx-runtime";
import Select from "@widget/forms/inputs/Select";
import Icon from "@icon/Icon";
/**
 * Language selector dropdown for auth pages
 * Uses full language names in dropdown (like UserProfile)
 */
const LanguageSelector = ({ languages, currentLanguage, onChange }) => {
    if (!languages || languages.length === 0) {
        return null;
    }
    // Get direction from selected language
    const selectedLang = languages.find(lang => lang.Code === currentLanguage);
    const direction = (selectedLang === null || selectedLang === void 0 ? void 0 : selectedLang.Direction) || 'ltr';
    const position = direction === 'rtl' ? 'bottom-left' : 'bottom-right';
    return (_jsx(Select, { options: languages, labelField: "Name", valueField: "Code", selected: currentLanguage, onChange: (value) => onChange(value), renderPlaceholder: {
            renderCustomPill: () => (_jsx("div", { className: "uxpcore_auth__language-selector-trigger", children: _jsx(Icon, { icon: ['fas', 'globe'] }) }))
        }, dropdownClassname: "uxpcore_auth__language-selector-input", position: position }));
};
export default LanguageSelector;
